import { gql } from '__generated__';

export default gql(`
  mutation DeleteLottery($id: ID!) {
    deleteLottery(id: $id)
  }
`);
